// Router components
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
// Generic components for pages
import IndexPage from '@/components/index.vue'
import StudentPage from '@/components/_flow-student/index.vue'
import TeacherPage from '@/components/_flow-teacher/index.vue'
import AdminPage from '@/components/_flow-admin/index.vue'
import SessionsPage from '@/components/sessions/index.vue'
// Generic pages
import NotFoundPage from '@/components/not-found.vue'
// Dev pages
import PageTester from '@/components/dev/page-tester'
import MediaTester from '@/components/dev/media-tester'
import FontTester from '@/components/dev/font-tester'
import AppConfig from '@/app-config';
import {getTeacherUrl} from "@/utils/UrlUtil";

// Allow Vue to use router methods and inject into components
Vue.use(VueRouter)

// Define routes in the app
let routes = [
	{
		path: '/',
		name: 'IndexPage',
		component: IndexPage
	},
	{
		path: '/student/:page',
		name: 'StudentPage',
		component: StudentPage
	},
	{
		path: '/teacher/:page',
		name: 'TeacherPage',
		component: TeacherPage
	},
	{
		path: '/admin/:page',
		name: 'AdminPage',
		component: AdminPage
	},
	{
		path: '/admin/:page/:id/:action',
		name: 'AdminActionPage',
		component: AdminPage
	},
	{
		path: '/admin/:page/add',
		name: 'AdminAddPage',
		component: AdminPage
	},
	{
		path: '/sessions',
		name: 'Sessions',
		component: SessionsPage
	},
	{
		path: '/page-tester',
		name: 'PageTester',
		component: PageTester
	},
	{ // default as it didn't match any other path
		path: '*',
		name: 'NotFoundPage',
		component: NotFoundPage
	},
]

if (AppConfig.isDev) {
	routes.unshift({
		path: '/dev/media-tester',
		name: 'MediaTesterPage',
		component: MediaTester,
	});

	routes.unshift({
		path: '/dev/font-tester',
		name: 'FontTesterPage',
		component: FontTester,
	});
}

let router = new VueRouter({
	linkActiveClass: 'is-active',
	base: '/', // window.location.href, - test if this breaks using scorm
	routes: routes
})

router.beforeEach((to, from, next) => {
	if (store.getters.getNavigationGuardEnabled) {
		console.log('Navigation guard says no!');
		return next(false); // NO!
	}

	return next();
});

export default router
